module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Ryan Hiller Portfolio","short_name":"Ryan Hiller","start_url":"/","display":"standalone","icon":"src/images/favicon-32x32.png","crossOrigin":"use-credentials","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"d5e6f431c152b77dea5eca6099c19819"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
